import { SeatComfort } from '@websky/graphql';
import { getGroupServices } from './getGroupServices';
import { getIsFreeSeat } from './getIsFreeSeat';
import { getSeatCombinedWith } from './getSeatCombinedWith';
export function splitRowsByGroups(rows) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const groupMap = new Map();
    // Find first available comfort
    let comfort = (_e = (_d = (_c = (_b = (_a = rows[0]) === null || _a === void 0 ? void 0 : _a.seats) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.seatService) === null || _d === void 0 ? void 0 : _d.comfort) !== null && _e !== void 0 ? _e : null;
    if (!comfort) {
        comfort =
            (_k = (_j = (_h = (_g = (_f = rows.find(row => { var _a; return (_a = row.seats) === null || _a === void 0 ? void 0 : _a.find(seat => { var _a; return (_a = seat === null || seat === void 0 ? void 0 : seat.seatService) === null || _a === void 0 ? void 0 : _a.comfort; }); })) === null || _f === void 0 ? void 0 : _f.seats) === null || _g === void 0 ? void 0 : _g[0]) === null || _h === void 0 ? void 0 : _h.seatService) === null || _j === void 0 ? void 0 : _j.comfort) !== null && _k !== void 0 ? _k : SeatComfort.Standard;
    }
    // Split rows by groups
    let groupIndex = 0;
    rows.forEach(row => {
        var _a, _b, _c, _d;
        const rowComfort = (_c = (_b = (_a = row.seats) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.seatService) === null || _c === void 0 ? void 0 : _c.comfort;
        if (rowComfort && rowComfort !== comfort) {
            comfort = rowComfort;
            groupIndex += 1;
        }
        const key = `${comfort}-${groupIndex}`;
        groupMap.set(key, [...((_d = groupMap.get(key)) !== null && _d !== void 0 ? _d : []), row]);
    });
    return [...groupMap.values()].map(rows => ({
        services: getGroupServices(rows),
        rows: rows.map(row => {
            var _a, _b;
            return (Object.assign(Object.assign({}, row), { seats: (_b = (_a = row.seats) === null || _a === void 0 ? void 0 : _a.map((seat, index) => (Object.assign(Object.assign({}, seat), { isFree: getIsFreeSeat(seat), combinedWith: getSeatCombinedWith(seat, row.seats, index) })))) !== null && _b !== void 0 ? _b : [] }));
        })
    }));
}
